exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  min-width: 1000px;\n  min-height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 999; }\n\n.modal {\n  position: absolute;\n  left: 50%;\n  transform: translate3d(-50%, -50%, 0);\n  background-color: #fefefe;\n  min-height: 200px;\n  width: 530px;\n  padding: 15px 15px 30px 15px;\n  border: 1px solid #888;\n  border-radius: 6px;\n  top: 40%;\n  z-index: 1000; }\n\n.modal-close-btn {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  border: none;\n  background: none;\n  color: #aaa;\n  font-size: 22px; }\n\n.modal-action-btns {\n  padding-top: 80px;\n  margin-bottom: 15px; }\n\napp-tg-button button {\n  padding: 5px; }\n\n.title {\n  padding-top: 60px;\n  margin: 0 0 10px 0;\n  font-size: 23px; }\n\napp-tg-button {\n  margin-right: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/modal-dialog/modal-dialog.component.scss
// module id = ../../../../../src/app/core/components/modal-dialog/modal-dialog.component.scss
// module chunks = main